import * as React from 'react';
import { Text, TextInput, StyleSheet, View, InteractionManager, ActivityIndicator } from 'react-native';
import { useField } from 'formik';

import InputIcon from '../components/form/InputIcon';
import FontStyles from '../constants/FontStyle';
import Colors from '../constants/Colors'

export default function CallRepSearchInput(props) {
  const { inputProps, groupProps, iconProps } = props;
  const [isFocused, setFocus] = React.useState(false);
  const inputRef = React.createRef();

  const focusInputWithKeyboard = () => {
    InteractionManager.runAfterInteractions(() => {
      try {
        inputRef.current.focus()
      } catch (e) {
        //
      }
    });
  }


  React.useEffect(() => {
    try {
      // focusInputWithKeyboard()
    } catch (e) {
      // do nothing
    }

    return () => {
    }
  }, [props]);

  return (
    <View style={[styles.inputGroup, { borderColor: isFocused ? '#3B54EC' : '#EAEAEA', paddingLeft: iconProps ? 0 : 14 }]} >
      {iconProps && <InputIcon {...iconProps} focused={isFocused} />}
      <TextInput
        ref={inputRef}
        autoFocus={true}
        onBlur={() => { setFocus(false); }}
        onFocus={() => setFocus(true)}
        {...inputProps}
        style={styles.inputControl}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  inputLabel: {
    color: Colors.shades._7,
    ...FontStyles.medium,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    marginTop: 21,
  },
  inputGroup: {
    flexGrow: 1,
    flexDirection: 'row',
    height: 38,
    borderColor: '#EAEAEA',
    borderStyle: 'solid',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  inputControl: {
    flexGrow: 1,
    ...FontStyles.dark,
    ...FontStyles.normal,
    ...FontStyles.size15,
    ...FontStyles.lh18,
  }
})